export const PurchaseOrdersRouter = [
  {
    path: '/purchase_orders/:uuidPurchase',
    name: 'PurchaseOrders',
    component: () => import('@/views/PurchaseOrders/PurchaseOrders.vue')
  },
  {
    path: '/purchase_orders/:uuidPurchase/order_details/:uuidDetail',
    name: 'PurchaseOrdersDetails',
    component: () => import('@/views/PurchaseOrders/PurchaseOrdersDetails.vue')
  }
];